import { ReactElement } from "react";
import { trackEvent } from "@leafly-com/web-utils";
import classnames from "classnames";
import PropTypes from "prop-types";

import TrackImpression from "components/TrackImpression";

import FinderButton from "../FinderButton";

type Props = {
  link: string;
  header: string;
  content: ReactElement;
  className: string;
  btnClasses: string;
  trackingInfo: {
    category: string;
    label: string;
  };
};

export const FinderLinkButton = ({
  link,
  header,
  content,
  className,
  btnClasses,
  trackingInfo,
}: Props) => (
  <a
    href={link}
    className={className}
    onClick={() => {
      trackEvent(trackingInfo.category, "Click", trackingInfo.label);
    }}
    data-testid={`${header}-button-link`}
  >
    <TrackImpression
      category={trackingInfo.category}
      label={trackingInfo.label}
      className="w-full h-full"
    >
      <FinderButton
        className={classnames(
          "justify-between p-md w-full ".concat(btnClasses)
        )}
      >
        <div className="text-xs flex flex-col text-left">
          <span className="text-green font-bold">{header}</span>
          <span>{content}</span>
        </div>
      </FinderButton>
    </TrackImpression>
  </a>
);

FinderLinkButton.propTypes = {
  btnClasses: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.node,
  header: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  trackingInfo: PropTypes.shape({
    category: PropTypes.string,
    label: PropTypes.string,
  }),
};

FinderLinkButton.defaultProps = {
  btnClasses: "",
  content: "Find nearby",
};

export default FinderLinkButton;
